export enum Territory {
    AUS = 'AUS',
    DEU = 'DEU',
    GBR = 'GBR',
    ITA = 'ITA',
    USA = 'USA',
}
